import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useQuery } from '@sorare/core/src/hooks/graphql/useQuery';

import { PromotionalEvents } from '#src/components/forYou/PromotionalEvents/index.tsx';
import { isMarketPromotion } from '#src/lib/promotionalEvent.ts';

import type {
  MarketBannerQuery,
  MarketBannerQueryVariables,
} from './__generated__/index.graphql.ts';

const MARKET_BANNER_QUERY = gql`
  query MarketBannerQuery($sport: Sport!) {
    tokens {
      promotionalEvents(sport: $sport) {
        slug
        ...PromotionalEvents_PromotionalEvent
      }
    }
  }
  ${PromotionalEvents.fragments.PromotionalEvent}
` as TypedDocumentNode<MarketBannerQuery, MarketBannerQueryVariables>;

export const MarketBanners = () => {
  const { sport } = useSportContext();
  const { data } = useQuery(MARKET_BANNER_QUERY, {
    variables: { sport },
  });

  const promotionalEvents =
    data?.tokens.promotionalEvents.filter(isMarketPromotion);
  if (promotionalEvents?.length) {
    return <PromotionalEvents promotionalEvents={promotionalEvents} />;
  }
  return null;
};
